import Client from '../client';
import { AxiosResponse } from 'axios';
import BaseService from '../baseService/baseService';

const RegrasExtrasFlexService = {
    deletarExcelParametros(fileRequest: any) {
        return BaseService.conectarEndpoint(fileRequest, 'flex/regras-extras/excel/deletar', 'excelRegrasExtrasFlexDeletar');
    },
    regrasExtrasFlexExcelPost(fileRequest: any) {
        return BaseService.conectarEndpoint(fileRequest, 'flex/regras-extras/excel', 'excelRegrasExtrasFlex');
    },
    obterExcel(): Promise<void | AxiosResponse<any>> {
        return Client.getBlob('flex/regras-extras/excel');
    },
    enviarParametrosAoEventGrid(): Promise<void | AxiosResponse<any>> {
        return Client.post('flex/regras-extras/eventGrid', {});
    }
};

export default RegrasExtrasFlexService;
